'use client'

import '@/sections/sections.css'

import type { ReactNode } from 'react'

import parse from 'html-react-parser'

import { useIsMobile } from '@/hooks/useIsMobile'
import useStore from '@/stores/Store'

type CardLetsConnectProps = {
  title?: string
  buttonText?: ReactNode
  subText?: ReactNode
  sideComponent?: ReactNode
}

function CardLetsConnect({ title, buttonText, subText, sideComponent }: CardLetsConnectProps) {
  const { formRef } = useStore()
  const isTab = useIsMobile({ maxWidth: '991px' })
  const isMobile = useIsMobile({ maxWidth: '480px' })

  return (
    <section
      className="section jumbotron"
      data-aos="zoom-in"
      data-aos-delay="200"
      style={{ paddingBottom: '8vh' }}
    >
      <div className="container">
        <div className="row">
          <div
            className="d-flex justify-content-between align-items-center p-0 flex-column-reverse flex-lg-row"
            style={{
              gap: isTab ? '40px' : '120px'
            }}
          >
            <div
              className="d-flex flex-column align-items-start text-start"
              style={{
                width: isTab ? '100%' : '75%'
              }}
            >
              <h2 className="jumbotron-subtitle">{title && parse(title)}</h2>
              <div className="jumbotron-subtext mb-3">{subText}</div>
              {buttonText && (
                <button
                  className="btn btn-primary btn-lg applybtn mb-3"
                  type="button"
                  onClick={() => {
                    if (formRef.current) {
                      const offset = 256 // Adjust this value as needed
                      const topPosition =
                        formRef.current.getBoundingClientRect().top + window.pageYOffset - offset
                      window.scrollTo({
                        top: topPosition,
                        behavior: 'smooth'
                      })
                    }
                    // formRef?.current?.scrollIntoView({ block: "end" })
                  }}
                  style={{
                    margin: isTab ? '0 auto' : '0',
                    width: isTab ? 'fit-content' : 'auto'
                  }}
                >
                  {buttonText}
                </button>
              )}
            </div>
            <div
              style={{
                margin: isTab ? '0 auto' : 'auto',
                width: isMobile ? '50%' : '25%'
              }}
            >
              {sideComponent}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CardLetsConnect
